import type { FeatureRoute } from '../types';
import { AdjustmentDetailPage, AdjustmentsListPage, NewAdjustmentPage } from './AdjustmentsPages';
import { CountDetailPage, CountsListPage } from './CountsPages';
import { LocationsPage } from './LocationsPage';
import { MovementsPage } from './MovementsPage';
import { OpeningStockPage } from './OpeningStockPage';
import { StockOnHandPage } from './StockOnHandPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'inventory', element: <StockOnHandPage /> },
  { path: 'inventory/movements', element: <MovementsPage /> },
  { path: 'inventory/adjustments', element: <AdjustmentsListPage /> },
  { path: 'inventory/adjustments/new', element: <NewAdjustmentPage /> },
  { path: 'inventory/adjustments/:id', element: <AdjustmentDetailPage /> },
  { path: 'inventory/counts', element: <CountsListPage /> },
  { path: 'inventory/counts/:id', element: <CountDetailPage /> },
  { path: 'inventory/opening', element: <OpeningStockPage /> },
  { path: 'inventory/locations', element: <LocationsPage /> },
];
